import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Icon } from '@iconify/react/dist/iconify.js';

import useErrors from '../hook/useErrors';
import { useAuth } from '../context/AuthContext';
import server from '../services/server';
import loginBrand from '../assets/imgs/logo-login.png';

const validationSchema = Yup.object().shape({
    username: Yup.string().email('Digite um email valido').required('Email e obrigatorio'),
    password: Yup.string().min(6, 'A senha deve ter pelo menos 6 caracteres').required('Senha e obrigatoria'),
});

const SignInLayer = ({ route = '' }) => {
    const [senhaVisivel, setSenhaVisivel] = useState(false);
    const navigate = useNavigate();
    const { setErrors, toast } = useErrors();
    const { Login } = useAuth();

    const { getFieldProps, handleSubmit, touched, errors, isValid, isSubmitting } = useFormik({
        initialValues: {
            username: '',
            password: '',
        },
        validationSchema,
        validateOnMount: true,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);

                const { data } = await server.post(`${route}/auth`, values);

                Login({ user: data.userData });
                toast.success('Login efetuado com sucesso.');
                navigate('/dashboard', { replace: true });
            } catch (error) {
                setErrors(error);
            } finally {
                setSubmitting(false);
            }
        },
    });

    return (
        <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 bg-light">
            <div className="card shadow border" style={{ maxWidth: '500px', width: '100%' }}>
                <div className="card-body p-5 d-flex flex-column align-items-center">
                    <header className="text-center mb-4 w-100">
                        <img
                            src={loginBrand}
                            alt="Katia Karine"
                            className="mb-3"
                            style={{ maxWidth: '260px', width: '100%', height: 'auto', objectFit: 'contain' }}
                        />
                        <h5 className="mb-2">Acessar</h5>
                        <p className="text-muted">Bem-vindo ao sistema da Katia Karine</p>
                    </header>

                    <form onSubmit={handleSubmit} noValidate className="w-100">
                        <div className="mb-3">
                            <div className="input-group">
                                <span className="input-group-text bg-transparent border-end-0">
                                    <Icon icon="mage:email" />
                                </span>
                                <input
                                    {...getFieldProps('username')}
                                    className={`form-control border-start-0 ${touched.username && errors.username ? 'is-invalid' : ''}`}
                                    placeholder="Email"
                                />
                            </div>
                            {touched.username && errors.username && (
                                <div className="text-danger small mt-1">{errors.username}</div>
                            )}
                        </div>

                        <div className="mb-3">
                            <div className="input-group">
                                <span className="input-group-text bg-transparent border-end-0">
                                    <Icon icon="solar:lock-password-outline" />
                                </span>
                                <input
                                    {...getFieldProps('password')}
                                    type={senhaVisivel ? 'text' : 'password'}
                                    className={`form-control border-start-0 ${touched.password && errors.password ? 'is-invalid' : ''}`}
                                    placeholder="Senha"
                                />
                                <button
                                    type="button"
                                    onClick={() => setSenhaVisivel((prev) => !prev)}
                                    className="btn btn-outline-secondary border-start-0"
                                >
                                    <Icon icon={senhaVisivel ? 'ri:eye-off-line' : 'ri:eye-line'} />
                                </button>
                            </div>
                            {touched.password && errors.password && (
                                <div className="text-danger small mt-1">{errors.password}</div>
                            )}
                        </div>

                        <div className="d-flex justify-content-end mb-3">
                            <Link to="/recuperar-senha" className="text-decoration-none">
                                <small className="text-primary">Perdeu a senha?</small>
                            </Link>
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary w-100"
                            disabled={!isValid || isSubmitting}
                        >
                            {isSubmitting ? 'Entrando...' : 'Entrar'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SignInLayer;
